
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React from 'react';

import { useQuery } from '../hooks/useQuery';
import Layout from '../layouts/default';
import { HOME_PAGE_QUERY } from '../queries/HOME_PAGE_QUERY.gql';
import { cmsDataService } from '../services/cms-data-service';
import Blocks from '../components/blocks/Blocks';
import StickyCardsStack from '../components/StickyCardsStack/StickyCardsStack';
import Footer from '../components/Footer/Footer';

const IndexPage = ({ preview }) => {
  const { loading, error, data } = useQuery(HOME_PAGE_QUERY);

  if (error) return <p>Error...</p>;
  if (!data && loading) return <p>Loading</p>;

  const { blocks, languageSwitch } = data.entry;

  const meta = {
    ...data.entry.customHeadMeta,
  };

  const { navigation, openingHours } = data.globalSet;

  return (
    <Layout
      meta={meta}
      languageSwitch={languageSwitch}
      navigation={navigation}
      openingHours={openingHours}
      preview={preview}
    >
      {data.entry.image && (
        <StickyCardsStack
          fixedImage={data.entry.image}
          items={data.entry.homepageSlider}
          title={data.entry.mainTitle}
          cta1={data.entry.ctaUrl}
          cta2={data.entry.ctaUrl2}
          linkTitle={data.entry.linkTitle}
          linkTitle2={data.entry.linkTitle2}
        />
      )}
      <div className="content">{blocks && <Blocks blocks={blocks} />}</div>
      <Footer openingHours={openingHours} />
    </Layout>
  );
};

 async function _getStaticProps(ctx) {
  // build queries
  const queries = [
    {
      query: HOME_PAGE_QUERY,
    },
  ];

  let url = process.env.siteUrl + '';
  if(ctx.locale === 'nl'){
    url = process.env.siteUrl + '/nl'
  }

  // wait for page data
  const pageProps = await cmsDataService.getPageProps({ ctx, queries, url });

  return {
    ...pageProps,
    revalidate: 20,
  };
}

export default IndexPage;


    export async function getStaticProps(ctx) {
        let res = _getStaticProps(ctx)
        if(typeof res.then === 'function') res = await res
        return {
          ...res,
          props: {
            ...(res.props || {}),
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/index',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              
            }))
          }
        }
    }
  